let _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

require('slick-carousel')
require('sweetalert')
require('jquery-modal')
require('./getCity')
require('./sliders')
require('./instagram')
require('./contact')
require('./login')
require('./forget')
require('./services')
require('./course')
require('./taller')
require('./recipe')
require('./subscribe')
require('./subscribeMob')


//LOGO CHANGE HEADER
window.addEventListener('scroll', function() {
  let logo1 = document.getElementById('logo1')
  let logo2 = document.getElementById('logo2')
  let header = document.getElementById('header')
  logo2.classList.toggle('dnone', window.scrollY > 100)
  header.classList.toggle('shadow', window.scrollY > 100)
  if(window.scrollY>100){
    logo1.classList.remove('dnone')
  } else{
    logo1.classList.add('dnone')
  }
})

//OPEN MENU HEADER
document.addEventListener("click", (evt) =>{
  const menu = document.getElementById("menuD")
  const openMenu = document.getElementById("contextMenu")
  let target = evt.target

  do{
    if(target == menu){
      //alert("hola")
      openMenu.style.display = "flex"
      return;
    }
    target = target.parentNode
  }while(target){
    openMenu.style.display = "none"
    }
})

/*===== MENU SHOW Y HIDDEN =====*/
const navMenu = document.getElementById('nav-menu'),
  toggleMenu = document.getElementById('nav-toggle'),
  closeMenu = document.getElementById('nav-close')

/*SHOW*/
toggleMenu.addEventListener('click', ()=>{
  navMenu.classList.toggle('show')
})

/*HIDDEN*/
closeMenu.addEventListener('click', ()=>{
  navMenu.classList.remove('show')
})

//up
$('.up').click(function () {
  $(window).scrollTop(0);
});
$('.up2').click(function () {
  $(window).scrollTop(0);
});

//modals
$('a.ctaUser').click(function(event) {
  $(this).modal({
    clickClose: false,
    showClose: true,
    fadeDuration: 120
  });
  return false;
});
$('.register a').click(function(event) {
  $(this).modal({
    clickClose: false,
    showClose: true,
    fadeDuration: 120
  });
  return false;
});

